var render = function render(){var _vm=this,_c=_vm._self._c;return _c('SntTagSuggestions',{attrs:{"value":_vm.value,"items":_vm.filteredItems,"width":_vm.width,"placeholder":"แท็ก","hide-details":""},on:{"input":function($event){return _vm.$emit('input', $event)}}})
}
var staticRenderFns = []

export { render, staticRenderFns }